import {
  collection,
  doc,
  getDocs,
  limit,
  orderBy,
  query,
  setDoc,
} from "firebase/firestore";
import { firestore } from "../firebase";
import { Cart, CartCollection, CartPricing, mapDocToCart } from "../types/Cart";

export async function createCart(cart: Cart, cartPricing: CartPricing) {
  cart.pricing = cartPricing;

  const cartRef = doc(firestore, CartCollection, cart.id);
  await setDoc(cartRef, cart);
}

export async function getRecentCarts() {
  const carts = await getDocs(
    query(
      collection(firestore, CartCollection),
      orderBy("startedDate", "desc"),
      limit(50),
    ),
  );

  return carts.docs.map((doc) => mapDocToCart(doc.data()));
}
